module.exports = __webpack_public_path__ + "img/环境1.139beb2b.png";